import { useAuth } from "@provider/context-auth";
import { Platform } from "react-native";

export function useAssistantEnabled() {
  const { isAuthenticated, profile } = useAuth();

  return Platform.OS === "web" && isAuthenticated && profile?.enabled_assistant === true;
}
